import routerOptions0 from "/usr/src/app/content/n3-treatments-02df28e1-651c-42de-94be-b780dccf2327/b2c-build/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}